import React from 'react';
import { openBrowserAsync } from 'expo-web-browser';

import { useTelemetry } from '@order/Telemetry';

import { OrgLinks } from '../../OrgLinksFooter/OrgLinksFooter.constants';

export const useAccountLinks = () => {
  const handleTermsLink = React.useCallback(() => {
    void openBrowserAsync(OrgLinks.terms);
  }, []);

  const handlePrivacyLink = React.useCallback(() => {
    void openBrowserAsync(OrgLinks.privacy);
  }, []);

  const handlePersonalInfoLink = React.useCallback(() => {
    void openBrowserAsync(OrgLinks.personal);
  }, []);

  return React.useMemo(
    () => ({
      handleTermsLink,
      handlePrivacyLink,
      handlePersonalInfoLink,
    }),
    [handleTermsLink, handlePrivacyLink, handlePersonalInfoLink],
  );
};

export const useSocialLinks = (withHref?: boolean) => {
  const { track } = useTelemetry();

  const handleInstagramTelemetry = React.useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.instagram);

    track('social_media_links', { link: 'instagram' });
  }, [track, withHref]);

  const handleTwitterTelemetry = React.useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.twitter);

    track('social_media_links', { link: 'twitter' });
  }, [track, withHref]);

  const handleTiktokTelemetry = React.useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.tiktok);

    track('social_media_links', { link: 'tiktok' });
  }, [track, withHref]);

  const handleSpotifyTelemetry = React.useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.spotify);

    track('social_media_links', { link: 'spotify' });
  }, [track, withHref]);

  const handleFacebookTelemetry = React.useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.facebook);

    track('social_media_links', { link: 'facebook' });
  }, [track, withHref]);

  return React.useMemo(
    () => ({
      handleInstagramTelemetry,
      handleTwitterTelemetry,
      handleTiktokTelemetry,
      handleSpotifyTelemetry,
      handleFacebookTelemetry,
    }),
    [
      handleInstagramTelemetry,
      handleTwitterTelemetry,
      handleTiktokTelemetry,
      handleSpotifyTelemetry,
      handleFacebookTelemetry,
    ],
  );
};
